import axios from 'axios'
import { apiUrl, axiosConfig } from 'config/apiConfig'

export const sendContactData = (data) => {
    return axios({
        method: 'post',
        url: `${apiUrl}contact.php`,
        data: data
    }, axiosConfig)
}